import { InjectionToken } from '@angular/core';
import type { Observable } from 'rxjs';

import type { IFilterResponse } from '../../shared/components/filter-bar/models/filter.model';

export interface FiltersClient {
  getFilters(organizationId: string): Observable<IFilterResponse>;
}

export const FILTERS_CLIENT = new InjectionToken<FiltersClient>('FILTERS_CLIENT');
